<template>
  <div class="px-6 py-6 overflow-y-auto">
    <h1 class="text-2xl font-semibold text-gray-800">Overview</h1>
    <div class="mt-2 grid grid-cols-4 gap-6">
      <div class="bg-white shadow rounded-md overflow-hidden flex flex-col">
        <div class="flex-grow px-4 py-4 flex items-center space-x-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
            />
          </svg>
          <div>
            <h2 class="text-base font-medium text-gray-500">
              จำนวนลูกค้าทั้งหมด
            </h2>
            <p class="text-xl font-semibold text-gray-800">
              {{ customersAll }} ราย
            </p>
          </div>
        </div>
        <div class="px-4 py-2 bg-gray-50 text-base font-medium text-cyan-600">
          <button
            type="button"
            class="font-medium"
            @click="
              handleCustomerDetails({
                type: 'all',
                title: 'จำนวนลูกค้าทั้งหมด',
              })
            "
          >
            ดูรายละเอียด
          </button>
        </div>
      </div>

      <div class="bg-white shadow rounded-md overflow-hidden flex flex-col">
        <div class="flex-grow px-4 py-4 flex items-center space-x-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
            />
          </svg>
          <div>
            <h2 class="text-base font-medium text-gray-500">
              จำนวนลูกค้าที่ใช้งาน
            </h2>
            <p class="text-xl font-semibold text-gray-800">
              {{ customerUseActive }} ราย
            </p>
          </div>
        </div>
        <div class="px-4 py-2 bg-gray-50 text-base font-medium text-cyan-600">
          <button
            type="button"
            class="font-medium"
            @click="
              handleCustomerDetails({
                type: 'use',
                title: 'จำนวนลูกค้าที่ใช้งาน',
              })
            "
          >
            ดูรายละเอียด
          </button>
        </div>
      </div>

      <div class="bg-white shadow rounded-md overflow-hidden flex flex-col">
        <div class="flex-grow px-4 py-4 flex items-center space-x-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
              clip-rule="evenodd"
            />
          </svg>
          <div>
            <h2 class="text-base font-medium text-gray-500">
              ลูกค้าใกล้หมดอายุใช้งาน
            </h2>
            <p class="text-xl font-semibold text-yellow-400">
              {{ customerUseNearExpiration }} ราย
            </p>
          </div>
        </div>
        <div class="px-4 py-2 bg-gray-50 text-base font-medium text-cyan-600">
          <button
            type="button"
            class="font-medium"
            @click="
              handleCustomerDetails({
                type: 'nearExpiration',
                title: 'ลูกค้าใกล้หมดอายุใช้งาน',
              })
            "
          >
            ดูรายละเอียด
          </button>
        </div>
      </div>

      <div class="bg-white shadow rounded-md overflow-hidden flex flex-col">
        <div class="flex-grow px-4 py-4 flex items-center space-x-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-gray-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z"
              clip-rule="evenodd"
            />
          </svg>
          <div>
            <h2 class="text-base font-medium text-gray-500">
              ลูกค้าหมดอายุการใช้งาน
            </h2>
            <p class="text-xl font-semibold text-red-600">
              {{ customerUseExpire }} ราย
            </p>
          </div>
        </div>
        <div class="px-4 py-2 bg-gray-50 text-base font-medium text-cyan-600">
          <button
            type="button"
            class="font-medium"
            @click="
              handleCustomerDetails({
                type: 'expire',
                title: 'ลูกค้าหมดอายุการใช้งาน',
              })
            "
          >
            ดูรายละเอียด
          </button>
        </div>
      </div>
    </div>

    <div class="mt-6 flex items-end justify-between">
      <h2 class="text-2xl font-semibold text-gray-800">
        {{ customerDetails.title }} {{ filterCustomers.total }} ราย
      </h2>
      <div>
        <SearchWidgetResultsList v-model="search" />
      </div>
    </div>

    <!-- table -->
    <div class="mt-4">
      <AppDataTable
        :isCheckbox="false"
        :options="options"
        :headers="[
          {
            text: 'รหัสลูกค้า',
            class: 'text-left w-28',
            value: 'company_code',
          },
          {
            text: 'ชื่อลูกค้า (ไทย)',
            class: 'text-left',
            value: 'title_th',
          },
          {
            text: 'ที่อยู่ (ไทย)',
            class: 'text-left',
            value: 'address_th',
          },
          {
            text: 'เริ่มต้นใช้งาน',
            class: 'text-left w-40',
            value: 'activate_start_date',
          },
          {
            text: 'สิ้นสุดการใช้งาน',
            class: 'text-left w-40',
            value: 'activate_end_date',
          },
        ]"
        :items="filterCustomers.items"
        :loading="loading"
        @sort="sort"
      >
        <template v-slot:title_th="{ item }">
          <button
            @click="
              $router.push({
                name: 'CustomerDetails',
                params: { uuid: item.company_uuid },
              })
            "
            type="button"
            class="text-cyan-600 font-medium hover:underline text-left"
          >
            {{ item.title_th }}
          </button>
        </template>
        <template v-slot:activate_start_date="{ item }">
          {{ item.activate_start_date | formatDate }}
        </template>
        <template v-slot:activate_end_date="{ item }">
          <span
            :class="
              (customerDetails.type === 'expire' &&
                'text-red-600 font-medium') ||
              (customerDetails.type === 'nearExpiration' &&
                'text-yellow-600 font-medium')
            "
          >
            {{ item.activate_end_date | formatDate }}
          </span>
        </template>
      </AppDataTable>
    </div>
    <!-- end table -->

    <!-- pagination -->
    <div class="py-4 flex items-center justify-start">
      <AppPagination
        :options="options"
        :startNumberItem="startNumberItem"
        :endNumberItem="endNumberItem"
        :totalItems="filterCustomers.total"
        :isPrevPage="isPrevPage"
        :isNextPage="isNextPage"
        @decreasePage="() => options.page--"
        @increasePage="() => options.page++"
        @itemsPerPageChange="() => (options.page = 1)"
      />
    </div>
    <!-- end pagination -->
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
import AppDataTable from '@/components/AppDataTable'
import AppPagination from '@/components/AppPagination'
import SearchWidgetResultsList from '@/components/SearchWidgetResultsList'

export default {
  name: 'Dashboard',

  components: {
    AppDataTable,
    AppPagination,
    SearchWidgetResultsList,
  },

  data() {
    return {
      loading: true,
      search: '',
      options: {
        sortBy: 'company_code',
        sortDesc: false,
        itemsPerPage: 10,
        page: 1,
      },
      customerDetails: {
        type: 'all',
        title: 'จำนวนลูกค้าทั้งหมด',
      },
    }
  },

  filters: {
    formatDate: function (value) {
      return value ? moment(String(value)).format('DD/MM/YYYY') : '-'
    },
  },

  watch: {
    search() {
      this.options.page = 1
    },
  },

  computed: {
    customerUseNearExpiration() {
      return this.$store.state.customer.customers
        .filter(
          (e) =>
            e.activate_end_date >= moment.utc(new Date()).format('YYYY-MM-DD')
        )
        .filter(
          (e) =>
            e.activate_end_date <=
            moment.utc(new Date()).add(1, 'M').format('YYYY-MM-DD')
        ).length
    },

    customerUseActive() {
      return this.$store.state.customer.customers.filter(
        (e) =>
          e.activate_end_date === null ||
          e.activate_end_date >= moment.utc(new Date()).format('YYYY-MM-DD')
      ).length
    },

    customerUseExpire() {
      return this.$store.state.customer.customers.filter(
        (e) => e.activate_end_date < moment.utc(new Date()).format('YYYY-MM-DD')
      ).length
    },

    customersAll() {
      return this.$store.state.customer.customers.length
    },

    customers() {
      return this.$store.state.customer.customers
    },

    filterCustomers() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let items = this.customers

      if (this.customerDetails.type === 'use') {
        items = items.filter(
          (e) =>
            e.activate_end_date === null ||
            e.activate_end_date >= moment.utc(new Date()).format('YYYY-MM-DD')
        )
      }

      if (this.customerDetails.type === 'nearExpiration') {
        items = items
          .filter(
            (e) =>
              e.activate_end_date >= moment.utc(new Date()).format('YYYY-MM-DD')
          )
          .filter(
            (e) =>
              e.activate_end_date <=
              moment.utc(new Date()).add(1, 'M').format('YYYY-MM-DD')
          )
      }

      if (this.customerDetails.type === 'expire') {
        items = items.filter(
          (e) =>
            e.activate_end_date < moment.utc(new Date()).format('YYYY-MM-DD')
        )
      }

      if (this.search) {
        items = items.filter((item) => {
          return Object.values({
            company_code: item.company_code,
            title_th: item.title_th,
            address_th: item.address_th || '',
            activate_start_date: item.activate_start_date
              ? moment(item.activate_start_date).format('DD/MM/YYYY')
              : '',
            activate_end_date: item.activate_end_date
              ? moment(item.activate_end_date).format('DD/MM/YYYY')
              : '',
          }).some((s) =>
            s.toString().toLowerCase().includes(this.search.toLowerCase())
          )
        })
      }

      items = items.sort((a, b) => {
        const sortA = a[sortBy] || ''
        const sortB = b[sortBy] || ''

        if (sortDesc) {
          if (sortA < sortB) return 1
          if (sortA > sortB) return -1
          return 0
        } else {
          if (sortA < sortB) return -1
          if (sortA > sortB) return 1
          return 0
        }
      })

      const total = items.length

      if (itemsPerPage > 0) {
        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
      }

      return { items, total }
    },

    startNumberItem() {
      if (this.filterCustomers.total === 0) return 0

      return (this.options.page - 1) * this.options.itemsPerPage + 1
    },

    endNumberItem() {
      const sum = this.options.page * this.options.itemsPerPage
      if (sum < this.filterCustomers.total) return sum

      return this.filterCustomers.total
    },

    isPrevPage() {
      if (this.options.page === 1) return true

      return false
    },

    isNextPage() {
      if (this.filterCustomers.length === 0) return true

      return (
        this.options.page ===
        Math.ceil(this.filterCustomers.total / this.options.itemsPerPage)
      )
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', false)
    this.$store.commit('setBreadcrumbs', [])

    this.fetchDataFromApi()
  },

  methods: {
    handleCustomerDetails(valueObj) {
      this.customerDetails = { ...valueObj }
      this.options.page = 1
    },

    sort(value) {
      if (this.options.sortBy === value) {
        this.options.sortDesc = !this.options.sortDesc
        this.options.page = 1
      } else {
        this.options.sortBy = value
        this.options.sortDesc = false
        this.options.page = 1
      }
    },

    async fetchDataFromApi() {
      try {
        this.loading = true

        await this.$store.dispatch('customer/fetchCustomers')
      } catch (error) {
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
